import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import tw from './i18n/tw';
import ch from './i18n/ch';

i18next.addResourceBundle('en', 'contact', en);
i18next.addResourceBundle('tw', 'contact', tw);
i18next.addResourceBundle('ch', 'contact', ch);

const ContactConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/contact',
			component: React.lazy(() => import('./Contact'))
		}
	]
};

export default ContactConfig;
